import React from 'react';
import { IoNavigate } from "react-icons/io5";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { TbLogout2 } from "react-icons/tb";
import { Link, useNavigate } from 'react-router-dom';
import logo from './Assets/magna.png';
import bgImage from './Assets/home-bg.png';

const MainMenu = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/');
  };

  return (
    <div
      className="flex flex-col items-center min-h-screen bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Logo */}
      <div className="mt-10 mb-8">
        <img src={logo} alt="Company Logo" className="w-24 h-auto" />
      </div>

      {/* Service Section */}
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold text-blue-700">Our Services</h2>
      </div>

      {/* Buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 w-full max-w-4xl px-4 mb-auto">
        <Link to="/directions" className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 hover:bg-blue-50 group">
          <IoNavigate size={60} className="text-blue-700 group-hover:text-blue-900" />
          <p className="mt-4 text-lg font-medium text-gray-700 group-hover:text-blue-900">Get Direction</p>
        </Link>

        <Link to="/salespoi" className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 hover:bg-blue-50 group">
          <FaMapMarkerAlt size={60} className="text-blue-700 group-hover:text-blue-900" />
          <p className="mt-4 text-lg font-medium text-gray-700 group-hover:text-blue-900">Get POI by Routes</p>
        </Link>

        <Link to="/nearbypoi" className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 hover:bg-blue-50 group">
          <FaMapMarkerAlt size={60} className="text-blue-700 group-hover:text-blue-900" />
          <p className="mt-4 text-lg font-medium text-gray-700 group-hover:text-blue-900">Get Nearby POI</p>
        </Link>
      </div>

      {/* Logout Button in the bottom-left corner */}
      <button
        onClick={handleLogout}
        className="absolute bottom-4 left-4 flex items-center p-2 rounded-full shadow-lg hover:bg-gray-200 transition-all duration-300"
      >
        <TbLogout2 size={30} className="text-blue-700" />
      </button>

      {/* Footer */}
      <div className="flex justify-center items-center text-gray-500 text-sm mt-auto py-4 w-full">
        <p>© Smartnet Magna Global {new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default MainMenu;
